// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>10</span>&nbsp;&nbsp;God is my shield that is over me;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;he saves the true of heart.<br> </p> </div></div>";
// Exports
module.exports = code;